import { render, staticRenderFns } from "./BankAccountEditor.vue?vue&type=template&id=7e4abc58"
import script from "./BankAccountEditor.vue?vue&type=script&lang=js"
export * from "./BankAccountEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports